import { render } from "./SystemBillOverdueGeneralPage.vue?vue&type=template&id=6ae8f886&scoped=true"
import script from "./SystemBillOverdueGeneralPage.vue?vue&type=script&lang=js"
export * from "./SystemBillOverdueGeneralPage.vue?vue&type=script&lang=js"

import "./SystemBillOverdueGeneralPage.vue?vue&type=style&index=0&id=6ae8f886&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ae8f886"]])

export default __exports__